@if (filter) {
  <section class="document-header">
    <h1>Relatório consolidado</h1>
    <app-print-filter-data [filter]="filter" />
  </section>

  @if (branchEntries.length) {
    <section class="part-section">
      <header>
        <h2>Diário Gerencial</h2>
      </header>

      @for (entry of branchEntries; track entry.id) {
        <article class="entry-section">
          <h3>{{ entry.label }}</h3>

          @switch (entry.managementDiaryState.status) {
            @case ('ready') {
              <app-print-management-diary
                [embedded]="true"
                [embeddedDataSummary]="entry.managementDiaryState.data?.dataSummary ?? null"
                [embeddedDataEvolution]="entry.managementDiaryState.data?.dataEvolution ?? null"
                [embeddedDataRanking]="entry.managementDiaryState.data?.dataRanking ?? null"
                [embeddedWordcloud]="entry.managementDiaryState.data?.wordcloud ?? null"
                [embeddedFilter]="filter"
              />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.managementDiaryState.message || 'Não há dados para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.managementDiaryState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }
    </section>

    <section class="part-section">
      <header>
        <h2>Engajamento</h2>
      </header>

      @for (entry of branchEntries; track entry.id) {
        <article class="entry-section">
          <h3>{{ entry.label }}</h3>

          @switch (entry.engagementState.status) {
            @case ('ready') {
              <app-engagement-report-body [data]="entry.engagementState.data" />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.engagementState.message || 'Não há dados para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.engagementState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }
    </section>

    <section class="part-section">
      <header>
        <h2>Feedback</h2>
      </header>

      @for (entry of branchEntries; track entry.id) {
        <article class="entry-section">
          <h3>{{ entry.label }}</h3>

          @switch (entry.feedbackState.status) {
            @case ('ready') {
              <app-feedback-report-body [data]="entry.feedbackState.data" />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.feedbackState.message || 'Não há dados para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.feedbackState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }
    </section>

    <section class="part-section">
      <header>
        <h2>Evolução</h2>
      </header>

      @for (entry of branchEntries; track entry.id) {
        <article class="entry-section">
          <h3>{{ entry.label }}</h3>

          @switch (entry.evolutionState.status) {
            @case ('ready') {
              <app-print-evolution
                [embedded]="true"
                [embeddedData]="entry.evolutionState.data"
                [embeddedFilter]="filter"
              />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.evolutionState.message || 'Não há dados para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.evolutionState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }
    </section>

    <section class="part-section page-break-before ">
      <header>
        <h2>Medidor</h2>
      </header>

      @for (entry of branchEntries; track entry.id) {
        <article class="entry-section avoid-page-break">
          <h3>{{ entry.label }}</h3>

          @switch (entry.meterState.status) {
            @case ('ready') {
              <app-print-meter
                [embedded]="true"
                [embeddedDataEvolution]="entry.meterState.data?.dataEvolution ?? null"
                [embeddedDataMeter]="entry.meterState.data?.dataMeter ?? null"
                [embeddedFilter]="filter"
              />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.meterState.message || 'Não há dados para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.meterState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }
    </section>

    @if (hasVisibleModule('shiftState')) {
      <section class="part-section">
        <header>
          <h2>Turno</h2>
        </header>

        @for (entry of branchEntries; track entry.id) {
          @if (entry.shiftState.status !== 'empty') {
            <article class="entry-section">
              <h3>{{ entry.label }}</h3>

              @switch (entry.shiftState.status) {
                @case ('ready') {
                  <app-print-shift
                    [embedded]="true"
                    [embeddedData]="entry.shiftState.data?.data ?? null"
                    [embeddedFilter]="filter"
                    [embeddedTotalResponses]="entry.shiftState.data?.totalResponses || 0"
                    [embeddedOverallSatisfaction]="entry.shiftState.data?.overallSatisfaction || 0"
                  />
                }
                @case ('error') {
                  <div class="module-state error">
                    <p>{{ entry.shiftState.message || 'Não foi possível carregar o módulo.' }}</p>
                  </div>
                }
                @default {
                  <div class="module-state">
                    <p>Carregando módulo...</p>
                  </div>
                }
              }
            </article>
          }
        }
      </section>
    }

    @if (hasVisibleModule('incentiveState')) {
      <section class="part-section">
        <header>
          <h2>Incentivo</h2>
        </header>

        @for (entry of branchEntries; track entry.id) {
          @if (entry.incentiveState.status !== 'empty') {
            <article class="entry-section">
              <h3>{{ entry.label }}</h3>

              @switch (entry.incentiveState.status) {
                @case ('ready') {
                  <app-print-incentive
                    [embedded]="true"
                    [embeddedData]="entry.incentiveState.data"
                    [embeddedFilter]="filter"
                  />
                }
                @case ('error') {
                  <div class="module-state error">
                    <p>{{ entry.incentiveState.message || 'Não foi possível carregar o módulo.' }}</p>
                  </div>
                }
                @default {
                  <div class="module-state">
                    <p>Carregando módulo...</p>
                  </div>
                }
              }
            </article>
          }
        }
      </section>
    }
  } @else {
    <div class="module-state empty">
      <p>{{ rootMessage }}</p>
    </div>
  }

  @if (deviceEntries.length) {
    <section class="part-section page-break-before">
      <header>
        <h2>Detalhamento por Filial/Dispositivo</h2>
      </header>
    </section>

    @for (entry of deviceEntries; track (entry.id || $index)) {
      <section class="part-section">
        <header>
          <h2>{{ entry.label }}</h2>
        </header>
      </section>

      <article class="entry-section">
        <h4>Diário Gerencial</h4>

        @switch (entry.managementDiaryState.status) {
          @case ('ready') {
            <app-print-management-diary
              [embedded]="true"
              [embeddedDataSummary]="entry.managementDiaryState.data?.dataSummary ?? null"
              [embeddedDataEvolution]="entry.managementDiaryState.data?.dataEvolution ?? null"
              [embeddedDataRanking]="entry.managementDiaryState.data?.dataRanking ?? null"
              [embeddedWordcloud]="entry.managementDiaryState.data?.wordcloud ?? null"
              [embeddedFilter]="filter"
            />
          }
          @case ('empty') {
            <div class="module-state empty">
              <p>{{ entry.managementDiaryState.message || 'Não há dados para exibir' }}</p>
            </div>
          }
          @case ('error') {
            <div class="module-state error">
              <p>{{ entry.managementDiaryState.message || 'Não foi possível carregar o módulo.' }}</p>
            </div>
          }
          @default {
            <div class="module-state">
              <p>Carregando módulo...</p>
            </div>
          }
        }
      </article>

      <article class="entry-section">
        <h4>Engajamento</h4>

        @switch (entry.engagementState.status) {
          @case ('ready') {
            <app-engagement-report-body [data]="entry.engagementState.data" />
          }
          @case ('empty') {
            <div class="module-state empty">
              <p>{{ entry.engagementState.message || 'Não há dados para exibir' }}</p>
            </div>
          }
          @case ('error') {
            <div class="module-state error">
              <p>{{ entry.engagementState.message || 'Não foi possível carregar o módulo.' }}</p>
            </div>
          }
          @default {
            <div class="module-state">
              <p>Carregando módulo...</p>
            </div>
          }
        }
      </article>

      <article class="entry-section">
        <h4>Feedback</h4>

        @switch (entry.feedbackState.status) {
          @case ('ready') {
            <app-feedback-report-body [data]="entry.feedbackState.data" />
          }
          @case ('empty') {
            <div class="module-state empty">
              <p>{{ entry.feedbackState.message || 'Não há dados de feedback para exibir' }}</p>
            </div>
          }
          @case ('error') {
            <div class="module-state error">
              <p>{{ entry.feedbackState.message || 'Não foi possível carregar o módulo.' }}</p>
            </div>
          }
          @default {
            <div class="module-state">
              <p>Carregando módulo...</p>
            </div>
          }
        }
      </article>

      <article class="entry-section">
        <h4>Evolução</h4>

        @switch (entry.evolutionState.status) {
          @case ('ready') {
            <app-print-evolution
              [embedded]="true"
              [embeddedData]="entry.evolutionState.data"
              [embeddedFilter]="filter"
            />
          }
          @case ('empty') {
            <div class="module-state empty">
              <p>{{ entry.evolutionState.message || 'Não há dados de evolução para exibir' }}</p>
            </div>
          }
          @case ('error') {
            <div class="module-state error">
              <p>{{ entry.evolutionState.message || 'Não foi possível carregar o módulo.' }}</p>
            </div>
          }
          @default {
            <div class="module-state">
              <p>Carregando módulo...</p>
            </div>
          }
        }
      </article>

      <article class="entry-section avoid-page-break">
        <h4>Medidor</h4>

        @switch (entry.meterState.status) {
          @case ('ready') {
            <app-print-meter
              [embedded]="true"
              [embeddedDataEvolution]="entry.meterState.data?.dataEvolution ?? null"
              [embeddedDataMeter]="entry.meterState.data?.dataMeter ?? null"
              [embeddedFilter]="filter"
            />
          }
          @case ('empty') {
            <div class="module-state empty">
              <p>{{ entry.meterState.message || 'Não há dados de medidor para exibir' }}</p>
            </div>
          }
          @case ('error') {
            <div class="module-state error">
              <p>{{ entry.meterState.message || 'Não foi possível carregar o módulo.' }}</p>
            </div>
          }
          @default {
            <div class="module-state">
              <p>Carregando módulo...</p>
            </div>
          }
        }
      </article>

      @if (entry.shiftState.status !== 'empty') {
        <article class="entry-section">
          <h4>Turno</h4>

          @switch (entry.shiftState.status) {
            @case ('ready') {
              <app-print-shift
                [embedded]="true"
                [embeddedData]="entry.shiftState.data?.data ?? null"
                [embeddedFilter]="filter"
                [embeddedTotalResponses]="entry.shiftState.data?.totalResponses || 0"
                [embeddedOverallSatisfaction]="entry.shiftState.data?.overallSatisfaction || 0"
              />
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.shiftState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }

      @if (entry.incentiveState.status !== 'empty') {
        <article class="entry-section">
          <h4>Incentivo</h4>

          @switch (entry.incentiveState.status) {
            @case ('ready') {
              <app-print-incentive
                [embedded]="true"
                [embeddedData]="entry.incentiveState.data"
                [embeddedFilter]="filter"
              />
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.incentiveState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }
    }
  }

  @if (deviceShiftEntries.length) {
    <section class="part-section page-break-before">
      <header>
        <h2>Detalhamento por Filial/Dispositivo/Turno</h2>
      </header>
    </section>

    @for (device of deviceShiftEntries; track (device.id || $index)) {
      <section class="part-section">
        <header>
          <h2>{{ device.label }}</h2>
        </header>
      </section>

      @for (entry of device.shifts; track (entry.id || $index)) {
        <section class="entry-section device-shift-section">
          <h3>{{ entry.label }}</h3>
        </section>

        <article class="entry-section">
          <h4>Diário Gerencial</h4>

          @switch (entry.managementDiaryState.status) {
            @case ('ready') {
              <app-print-management-diary
                [embedded]="true"
                [embeddedDataSummary]="entry.managementDiaryState.data?.dataSummary ?? null"
                [embeddedDataEvolution]="entry.managementDiaryState.data?.dataEvolution ?? null"
                [embeddedDataRanking]="entry.managementDiaryState.data?.dataRanking ?? null"
                [embeddedWordcloud]="entry.managementDiaryState.data?.wordcloud ?? null"
                [embeddedFilter]="filter"
              />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.managementDiaryState.message || 'Não há dados para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.managementDiaryState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>

        <article class="entry-section">
          <h4>Engajamento</h4>

          @switch (entry.engagementState.status) {
            @case ('ready') {
              <app-engagement-report-body [data]="entry.engagementState.data" />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.engagementState.message || 'Não há dados para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.engagementState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>

        <article class="entry-section">
          <h4>Feedback</h4>

          @switch (entry.feedbackState.status) {
            @case ('ready') {
              <app-feedback-report-body [data]="entry.feedbackState.data" />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.feedbackState.message || 'Não há dados de feedback para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.feedbackState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>

        <article class="entry-section">
          <h4>Evolução</h4>

          @switch (entry.evolutionState.status) {
            @case ('ready') {
              <app-print-evolution
                [embedded]="true"
                [embeddedData]="entry.evolutionState.data"
                [embeddedFilter]="filter"
              />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.evolutionState.message || 'Não há dados de evolução para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.evolutionState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>

        <article class="entry-section avoid-page-break">
          <h4>Medidor</h4>

          @switch (entry.meterState.status) {
            @case ('ready') {
              <app-print-meter
                [embedded]="true"
                [embeddedDataEvolution]="entry.meterState.data?.dataEvolution ?? null"
                [embeddedDataMeter]="entry.meterState.data?.dataMeter ?? null"
                [embeddedFilter]="filter"
              />
            }
            @case ('empty') {
              <div class="module-state empty">
                <p>{{ entry.meterState.message || 'Não há dados de medidor para exibir' }}</p>
              </div>
            }
            @case ('error') {
              <div class="module-state error">
                <p>{{ entry.meterState.message || 'Não foi possível carregar o módulo.' }}</p>
              </div>
            }
            @default {
              <div class="module-state">
                <p>Carregando módulo...</p>
              </div>
            }
          }
        </article>
      }
    }
  }

  @if (hasVisibleModule('searchOnlineState')) {
    <section class="part-section page-break-before">
      <header>
        <h2>Pesquisa Online</h2>
      </header>

      @for (entry of branchEntries; track entry.id) {
        @if (entry.searchOnlineState.status !== 'empty') {
          <article class="entry-section">

            @switch (entry.searchOnlineState.status) {
              @case ('ready') {
                <app-feedback-report-body [data]="entry.searchOnlineState.data" />
              }
              @case ('error') {
                <div class="module-state error">
                  <p>{{ entry.searchOnlineState.message || 'Não foi possível carregar o módulo.' }}</p>
                </div>
              }
              @default {
                <div class="module-state">
                  <p>Carregando módulo...</p>
                </div>
              }
            }
          </article>
        }
      }
    </section>
  }
}
